/**
 * English: org_id + station_id for agent-management API calls (memory-service, etc.).
 * Thai: org_id และ station_id สำหรับเรียก API ใน agent-management
 */
import { useChatOrgContext } from '../../hooks/useChatOrgContext';

/** @deprecated Use useAgentManagementOrgContext on agent-management routes, or useChatOrgContext elsewhere. */
export function useAgentOrgContext(): { orgId: string; stationId: string } {
  return useChatOrgContext();
}
